import gql from 'graphql-tag'

const BIG_BOOKINGS_QUERY =gql`query {
    
    token{
        id
        email
        user{
            id
            name
            phone
            in_phone
            email
            gender
            nationality
            address
            date_of_birth
            is_deactivated
            coins
            extra_coins
            picture
            identification_number
            verified 
            bookings{
                id
                user_id
                day_date
                uuid
                attended
                slot{
                    id
                    start_date
                    end_date
                    start_time
                    end_time
                    monday
                    tuesday
                    wednesday
                    thursday
                    friday
                    saturday
                    sunday
                    points_cost
                    cash_cost
                    pay_points
                    pay_cash
                    capacity
                    instructor_name
                    registered
                    bookings_counts{
                        booking_day_date
                        registered
                    }
                    class{
                    id
                    name
                    instructor_name
                    level
                    business_id
                    image_1
                    image_2
                    image_3
                    image_4
                    image_5
                    image_6
                    image_7
                    image_8
                    location{
                        id
                        address
                        location_city{
                            id
                            name
                            county_id
                        }
                    }
                    business{
                        id
                        name
                        logo
                    }
                    categories{
                        category{
                            id
                            name
                        }
                    }
                    }
                    instructor{
                        id
                        name
                        logo
                    } 
                }    
            }
        }
    }
}`;

const TOKEN_AND_USER_QUERY = gql`query {
    token{
        id
        email
        user{
            id
            name
            phone
            in_phone
            email
            gender
            nationality
            address
            date_of_birth
            is_deactivated
            coins
            extra_coins
            picture
            identification_number
            verified
        }
    }
}`;

const TOKEN_QUERY = gql`query {
    token{
        id
        email
    }
}`;

const MY_USER_QUERY = gql`query{
    
    token{
        id
        user{
            id
            name
            phone
            in_phone
            email
            gender
            nationality
            address
            date_of_birth
            is_deactivated
            coins
            extra_coins
            picture
            identification_number
            verified
            is_client
            is_business
        }
    }
}`;

const USER_INFO_QUERY = gql`query($userEmail: String!){
    user(where:{email: {_eq: $userEmail}}){
        id
        name
        phone
        in_phone
        email
        gender
        nationality
        address
        date_of_birth
        is_deactivated
        coins
        extra_coins
        picture
        identification_number
        verified
        is_client
        is_business
        social_media
    }
}`;



const BROKER_USER_INFO = gql`query($userId: Int!){
    broker(where:{user_id: {_eq: $userId}}){
        id
        percentage
        points
    }
}`;


const USER_MAIN_QUERY = gql`query{
       
    token{
        id
        user{
            id
            name
            phone
            in_phone
            email
            gender
            nationality
            address
            date_of_birth
            is_deactivated
            coins
            extra_coins
            picture
            identification_number
            verified
            is_client
            is_business
        }
    }
}`;


const iOS_TOKEN_USER_QUERY = gql`query{
    
    token{
        id
        user{
            id
            name
            phone
            in_phone
            email
            gender
            nationality
            address
            date_of_birth
            is_deactivated
            coins
            extra_coins
            picture
            identification_number
            verified
            is_client
            is_business
            is_broker
            user_devices(order_by: {updated_at: desc}){
                id
                device_id
                fcm_token
                device_os
                updated_at
            }
            user_push_subscriptions(order_by:{updated_at: desc}){
       
                id
                end_point
                auth
                p256dh
            }
        }
    }
}`;

const CLASS_USER_QUERY = gql`query($tokenId: String!){
    user(where:{token_id: {_eq: $tokenId}}){
        id
        name
        phone
        email
        gender
        nationality
        address
        date_of_birth
        is_deactivated
        coins
        extra_coins
        picture
        identification_number
    }
}`;

const DELEGATED_USER_INFO_QUERY = gql`query($delegatedUserEmail: String!) {
    
    user(where:{email: {_eq: $delegatedUserEmail}})
        {
            id
            name
            email
    }
}`;

const INSTRUCTORS_QUERY = gql`query{
    
    brand(where: {is_instructor: {_eq: true}}){
            id
            name
            phone
            logo
            description
        brand_to_brand_categories{
            brand_category{
                id
                name
            }
        }
    }
}`;

const ONE_BUSINESS_QUERY = gql`query($businessId: Int!){
    
    business(where: {id: {_eq: $businessId}}){
            
            id
            phone
            name
            address
            owner_id
            logo
            license
            location{
            id
            name
            latitude
            longitude
            url
            address
            business_id
            country
            location_city{
                id
                name
                county_id
                }
            }
        }
    }`;

const ONE_INSTRUCTOR_QUERY = gql`query($instructorId: Int!){
    
    brand(where: {id: {_eq: $instructorId}}){
            id
            name
            phone
            logo
            description
            brand_to_brand_categories{
                brand_category{
                    id
                    name
                }
            }
    }
}`;



const ALL_DELEGATED_USERS_QUERY = gql`query {
    delegated_user{
        
        delegated_user_id
        delegated_user_email
        business{
            id
            name
        }
    }
}`;

    //$idToken
const BRAND_QUERY = gql`query($userId: Int!){
    brand(where: {user_id: {_eq: $userId}}, order_by: {id: desc}){
        
        id
        phone
        name
        logo
        is_instructor
        license
        verified
        brand_to_brand_categories{
            brand_category{
                id
                name
            }
        }
    }
}`;

//name ??
const CLASSES_BRAND_QUERY = gql`query{
    brand(order_by: {id: desc}){
        
        id
        phone
        name
        logo
        is_instructor
        license
        brand_to_brand_categories{
            brand_category{
                id
                name
            }
        }
    }
}`;

const BRAND_CATEGORY_QUERY = gql`query{
    brand_category(order_by: {name: asc}){
        id
        name
    }
}`;

const BUSINESS_QUERY = gql`query($ownerId: Int!){
    business(where:{owner_id: {_eq: $ownerId}}, order_by:{id: desc}) {
        id
        phone
        name
        address
        location_id
        owner_id
        logo
        license
        is_private
        sub_merchant_id
        business_to_business_clients{
            id
            user{
            id
            name
            email
            }
        }
        verified
        brand{
            id
            name
            is_instructor
            description
            verified
        }
        location{
            id
            name
            latitude
            longitude
            url
            address
            business_id
            country
            country_code
            location_city{
                id
                name
                county_id
            }
        }
        user_business_points{
            points
          }
    }
}`;

const BROKER_BUSINESS = gql`query($brokerId: Int!){
    business(where:{broker_id: {_eq: $brokerId}}, order_by:{id: desc}) {
        id
        phone
        name
        address
        location_id
        owner_id
        logo
        license
        is_private
        sub_merchant_id
        verified
        brand{
            id
            name
            is_instructor
            description
            verified
        }
        location{
            id
            name
            latitude
            longitude
            url
            address
            business_id
            country
            country_code
            location_city{
                id
                name
                county_id
            }
        }
        user_business_points{
            id
            points
            cash
            total_points
            total_cash
            transfer_requests(order_by:{id: desc}){
                id
                points
            }
          }
    }
}`;

const ALL_BUSINESS_QUERY = gql`query{
    business{
        id
        phone
        name
        address
        location_id
        owner_id
        logo
        license
        is_private
        sub_merchant_id
        verified
        brand{
            id
            logo
            name
            is_instructor
            description
            verified
        }
        location{
            id
            name
            latitude
            longitude
            url
            address
            business_id
            country
            location_city{
                id
                name
                county_id
            }
        }
        user_business_points{
            
            points
        }
    }
}`;

const OWNER_BUSINESS_QUERY = gql`query($ownerId: Int!){
    business(where:{owner_id: {_eq: $ownerId}}, order_by:{id: desc}) {
        id
        phone
        name
        address
        location_id
        owner_id
        logo
        license
        is_private
        sub_merchant_id
        brand{
            id
            name
            is_instructor
        }
        location{
            id
            name
            latitude
            longitude
            url
            address
            business_id
            location_city{
                id
                name
                county_id
            }
        }
        classes{
            id
            name
            points_cost
            cash_cost
            pay_points
            pay_cash
            instructor_name
            instructor_id
            instructor{
                id
                name
            }
        }
        user_business_points{
            
            points
        }
    }
}`;


const LOCATION_QUERY = gql`query{
    location(order_by:{name: asc}) {
        id
        name
        address
        latitude
        longitude
        url
        business_id
        location_city{
            id
            name
        }
    }
}`;

const ALL_CLASS_QUERY = gql`{
    class(order_by:{name: asc}) {
        id
        name
        location_id
        created_by_user
        description
        instructor_id
        image_1
        image_2
        image_3
        image_4
        image_5
        image_6
        image_7
        image_8
        token_id
        level
        points_cost
        cash_cost
        pay_points
        pay_cash
        is_online
        pay_cash
        pay_points
        business_id
        my_time_stamp
        instructor_name
        categories{
            category_id
        }
        location{
            id
            name
            latitude
            longitude
            url
            address
            business_id
            location_city{
                id
                name
                county_id
            }
        }
        instructor{
            id
            name
            logo
        }
        location{
            address
            location_city{
                id
                name
                county_id
            }
        }
        business{
            id
            name
            logo
        }
    }
}`;

const CLASS_QUERY = gql`query($businessId: Int!){
    class(where: {business_id: {_eq: $businessId}}, order_by:{name: asc}) {
        id
        name
        location_id
        created_by_user
        instructor_id
        image_1
        image_2
        image_3
        image_4
        image_5
        image_6
        image_7
        image_8
        token_id
        level
        points_cost
        cash_cost
        pay_points
        pay_cash
        is_online
        pay_cash
        pay_points
        business_id
    }
}`;

const CLASS_MALES_QUERY = gql`query($classId: Int!, $todayDate: date!){
    class(where: {id: {_eq: $classId}}, order_by:{name: asc}) {
        id
        name
        location_id
        created_by_user
        instructor_id
        image_1
        image_2
        image_3
        image_4
        image_5
        image_6
        image_7
        image_8
        token_id
        level
        points_cost
        cash_cost
        pay_points
        pay_cash
        is_online
        instructor{
            id
            name
        }
        class_ratings_aggregate
        {
            aggregate 
            {
                avg {
                    rating
                }
            }
        }
        location{
            id
            name
            address
            latitude
            longitude
            url
            business_id
            location_city{
                id
                name
                county_id
            }
        }
        business{
            id
            name
            logo
            is_private
            three_gym_memberships{
                id
                include_classes
                three_user_gym_memberships(where: {end_date: {_gte: $todayDate}}){
                    id
                    user_id
                    membership_id
                    start_date
                    end_date
                }
            }
            three_studio_memberships{
                id
                include_classes
                three_user_studio_memberships(where: {end_date: {_gte: $todayDate}}){
                    id
                    user_id
                    membership_id
                    start_date
                    end_date
                }
            }
        }
        categories{
            category{
                id
                name
            }
        }
        business_id
        slots(
            where:  {_and:[
            {end_date: {_gte: $todayDate}},
            {males: {_eq: true}}
            ]},
            order_by:{start_date: asc, start_time: asc}) {
            id
            start_date
            end_date
            start_time
            end_time
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
            sunday
            points_cost
            cash_cost
            pay_points
            pay_cash
            capacity
            instructor_name
            registered
            link
            males
            females
            bookings_counts{
                booking_day_date
                registered
            }
            instructor{
                id
                name
                logo
            }
            bookings{
                id
                user_id
                day_date
                uuid
                attended
                user{
                    name
                    picture
                    gender
                    date_of_birth
                    phone
                    email
                }
            }
        }
    }
}`;

const CLASS_FEMALES_QUERY = gql`query($classId: Int!, $todayDate: date!){
    class(where: {id: {_eq: $classId}}, order_by:{name: asc}) {
        id
        name
        location_id
        created_by_user
        instructor_id
        image_1
        image_2
        image_3
        image_4
        image_5
        image_6
        image_7
        image_8
        token_id
        level
        points_cost
        cash_cost
        pay_points
        pay_cash
        is_online
        instructor{
            id
            name
        }
        class_ratings_aggregate
        {
            aggregate 
            {
                avg {
                    rating
                }
            }
        }
        location{
            id
            name
            address
            latitude
            longitude
            url
            business_id
            location_city{
                id
                name
                county_id
            }
        }
        business{
            id
            name
            logo
            is_private
            three_gym_memberships{
                id
                include_classes
                three_user_gym_memberships(where: {end_date: {_gte: $todayDate}}){
                    id
                    user_id
                    membership_id
                    start_date
                    end_date
                }
            }
            three_studio_memberships{
                id
                include_classes
                three_user_studio_memberships(where: {end_date: {_gte: $todayDate}}){
                    id
                    user_id
                    membership_id
                    start_date
                    end_date
                }
            }
        }
        categories{
            category{
                id
                name
            }
        }
        business_id
        slots(
            where:  {_and:[
            {end_date: {_gte: $todayDate}},
            {females: {_eq: true}}
            ]}, 
            order_by:{start_date: asc, start_time: asc}) {
            id
            start_date
            end_date
            start_time
            end_time
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
            sunday
            points_cost
            cash_cost
            pay_points
            pay_cash
            capacity
            instructor_name
            registered
            link
            males
            females
            bookings_counts{
                booking_day_date
                registered
            }
            instructor{
                id
                name
                logo
            }
            bookings{
                id
                user_id
                day_date
                uuid
                attended
                user{
                    name
                    picture
                    gender
                    date_of_birth
                    phone
                    email
                }
            }
        }
    }
}`;



const CLASS_MIXED_ONLY_QUERY = gql`query($classId: Int!, $todayDate: date!){
    class(where: {id: {_eq: $classId}}, order_by:{name: asc}) {
        id
        name
        location_id
        created_by_user
        instructor_id
        image_1
        image_2
        image_3
        image_4
        image_5
        image_6
        image_7
        image_8
        token_id
        level
        points_cost
        cash_cost
        pay_points
        pay_cash
        is_online
        instructor{
            id
            name
        }
        class_ratings_aggregate
        {
            aggregate 
            {
                avg {
                    rating
                }
            }
        }
        location{
            id
            name
            address
            latitude
            longitude
            url
            business_id
            location_city{
                id
                name
                county_id
            }
        }
        business{
            id
            name
            logo
            is_private
            three_gym_memberships{
                id
                include_classes
                three_user_gym_memberships(where: {end_date: {_gte: $todayDate}}){
                    id
                    user_id
                    membership_id
                    start_date
                    end_date
                }
            }
            three_studio_memberships{
                id
                include_classes
                three_user_studio_memberships(where: {end_date: {_gte: $todayDate}}){
                    id
                    user_id
                    membership_id
                    start_date
                    end_date
                }
            }
        }
        categories{
            category{
                id
                name
            }
        }
        business_id
        slots(where: {_and:[
            {end_date: {_gte: $todayDate}},
            {males: {_eq: true}},
            {females: {_eq: true}}
        ]}, order_by:{start_date: asc, start_time: asc})
         {
            id
            start_date
            end_date
            start_time
            end_time
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
            sunday
            points_cost
            cash_cost
            pay_points
            pay_cash
            capacity
            instructor_name
            registered
            link
            males
            females
            bookings_counts{
                booking_day_date
                registered
            }
            instructor{
                id
                name
                logo
            }
            bookings{
                id
                user_id
                day_date
                uuid
                attended
                user{
                    name
                    picture
                    gender
                    date_of_birth
                    phone
                    email
                }
            }
        }
    }
}`;

const CATEGORY_QUERY = gql`query{
    category(order_by:{name: asc}) {
        id
        name
        is_ma
    }
}`;

const FAKE_SLOTS = gql`query{
    fake_slot(order_by:{start_date: asc, start_time: asc}) {
        id
        start_date
        end_date
        start_time
        end_time
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        points_cost
        cash_cost
        pay_points
        pay_cash
        capacity
        instructor_name
        registered
        link
        males
        females
        bookings_counts{
            booking_day_date
            registered
        }
        instructor{
            id
            name
            logo
        }
        bookings{
            id
            user_id
            day_date
            uuid
            attended
            user{
                name
                picture
                gender
                date_of_birth
                phone
                email
            }
        }
        class{
            id
            name
            instructor_name
            level
            points_cost
            cash_cost
            pay_points
            pay_cash
            business_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            is_online
            description
            instructor{
                id
                name
            }
            class_ratings_aggregate
            {
                aggregate 
                {
                    avg {
                        rating
                    }
                }
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                business_id
                location_city{
                    id
                    name
                    county_id
                }
            }
            business{
                id
                name
                logo
                is_private
            }
            categories{
                category{
                    id
                    name
                }
            }
        }
    }
}`;

const SLOT_QUERY = gql`query{
    slot(order_by:{start_date: asc, start_time: asc}) {
        id
        start_date
        end_date
        start_time
        end_time
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        points_cost
        cash_cost
        pay_points
        pay_cash
        capacity
        instructor_name
        registered
        link
        males
        females
        bookings_counts{
            booking_day_date
            registered
        }
        instructor{
            id
            name
            logo
        }
        bookings{
            id
            user_id
            day_date
            uuid
            attended
            user{
                name
                picture
                gender
                date_of_birth
                phone
                email
            }
        }
        class{
            id
            name
            instructor_name
            level
            points_cost
            cash_cost
            pay_points
            pay_cash
            business_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            is_online
            description
            instructor{
                id
                name
            }
            class_ratings_aggregate
            {
                aggregate 
                {
                    avg {
                        rating
                    }
                }
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                business_id
                location_city{
                    id
                    name
                    county_id
                }
            }
            business{
                id
                name
                logo
                is_private
            }
            categories{
                category{
                    id
                    name
                }
            }
        }
    }
}`;

const SLOT_MY_BUSINESS_QUERY = gql`query($tokenId: String!){
    slot(where: {token_id: {_eq: $tokenId}}, order_by:{start_date: asc, start_time: asc}) {
        id
        start_date
        end_date
        start_time
        end_time
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        points_cost
        cash_cost
        pay_points
        pay_cash
        capacity
        instructor_name
        registered
        link
        males
        females
        bookings_counts{
            booking_day_date
            registered
        }
        instructor{
            id
            name
            logo
        }
        bookings{
            id
            user_id
            day_date
            uuid
            attended
            user{
                name
                picture
                gender
                date_of_birth
                phone
                email
            }
        }
        class{
            id
            name
            instructor_name
            level
            points_cost
            cash_cost
            pay_points
            pay_cash
            business_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            is_online
            description
            instructor{
                id
                name
            }
            class_ratings_aggregate
            {
                aggregate 
                {
                    avg {
                        rating
                    }
                }
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                business_id
                location_city{
                    id
                    name
                    county_id
                }
            }
            business{
                id
                name
                logo
                is_private
            }
            categories{
                category{
                    id
                    name
                }
            }
        }
    }
}`;


const SLOT_MALES_QUERY = gql`query($todayDate: date!){
    slot(
        where:  {_and:[
        {end_date: {_gte: $todayDate}},
        {males: {_eq: true}},
        {class: {business: {_and:[
            {verified: {_eq: true}},
            {brand: {verified: {_eq: true}}}
        ]}}}
        ]},
        order_by:{start_date: asc, start_time: asc}) {

        id
        start_date
        end_date
        start_time
        end_time
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        points_cost
        cash_cost
        pay_points
        pay_cash
        capacity
        instructor_name
        registered
        link
        males
        females
        bookings_counts{
            booking_day_date
            registered
        }
        instructor{
            id
            name
            logo
        }
        bookings{
            id
            user_id
            day_date
            uuid
            attended
            user{
                name
                picture
                gender
                date_of_birth
                phone
                email
            }
        }
        class{
            id
            name
            instructor_name
            level
            points_cost
            cash_cost
            pay_points
            pay_cash
            business_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            is_online
            description
            instructor{
                id
                name
            }
            class_ratings_aggregate
            {
                aggregate 
                {
                    avg {
                        rating
                    }
                }
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                business_id
                location_city{
                    id
                    name
                    county_id
                }
            }
            business{
                id
                name
                logo
                is_private
                three_gym_memberships{
                    id
                    include_classes
                    three_user_gym_memberships(where: {end_date: {_gte: $todayDate}}){
                        id
                        user_id
                        membership_id
                        start_date
                        end_date
                    }
                }
                three_studio_memberships{
                    id
                    include_classes
                    three_user_studio_memberships(where: {end_date: {_gte: $todayDate}}){
                        id
                        user_id
                        membership_id
                        start_date
                        end_date
                    }
                }
            }
            categories{
                category{
                    id
                    name
                }
            }
        }
    }
}`;

const SLOT_FEMALES_QUERY = gql`query($todayDate: date!){
    slot(
        where:  {_and:[
        {end_date: {_gte: $todayDate}},
        {females: {_eq: true}},
        {class: {business: {_and:[
            {verified: {_eq: true}},
            {brand: {verified: {_eq: true}}}
        ]}}}
        ]}, 
        order_by:{start_date: asc, start_time: asc}) {
        id
        start_date
        end_date
        start_time
        end_time
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        points_cost
        cash_cost
        pay_points
        pay_cash
        capacity
        instructor_name
        registered
        link
        males
        females
        bookings_counts{
            booking_day_date
            registered
        }
        instructor{
            id
            name
            logo
        }
        bookings{
            id
            user_id
            day_date
            uuid
            attended
            user{
                name
                picture
                gender
                date_of_birth
                phone
                email
            }
        }
        class{
            id
            name
            instructor_name
            level
            points_cost
            cash_cost
            pay_points
            pay_cash
            business_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            is_online
            description
            instructor{
                id
                name
            }
            class_ratings_aggregate
            {
                aggregate 
                {
                    avg {
                        rating
                    }
                }
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                business_id
                location_city{
                    id
                    name
                    county_id
                }
            }
            business{
                id
                name
                logo
                is_private
                three_gym_memberships{
                    id
                    include_classes
                    three_user_gym_memberships(where: {end_date: {_gte: $todayDate}}){
                        id
                        user_id
                        membership_id
                        start_date
                        end_date
                    }
                }
                three_studio_memberships{
                    id
                    include_classes
                    three_user_studio_memberships(where: {end_date: {_gte: $todayDate}}){
                        id
                        user_id
                        membership_id
                        start_date
                        end_date
                    }
                }
            }
            categories{
                category{
                    id
                    name
                }
            }
        }
    }
}`;

const SLOT_MIXED_ONLY_QUERY = gql`query($todayDate: date!){
    slot(where: {_and:[
        {end_date: {_gte: $todayDate}},
        {males: {_eq: true}},
        {females: {_eq: true}},
        {class: {business: {_and:[
            {verified: {_eq: true}},
            {brand: {verified: {_eq: true}}}
            ]}}}
    ]}, order_by:{start_date: asc, start_time: asc})
     {
        id
        start_date
        end_date
        start_time
        end_time
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        points_cost
        cash_cost
        pay_points
        pay_cash        
        capacity
        instructor_name
        registered
        link
        males
        females
        bookings_counts{
            booking_day_date
            registered
        }
        instructor{
            id
            name
            logo
        }
        bookings{
            id
            user_id
            day_date
            uuid
            attended
            user{
                name
                picture
                gender
                date_of_birth
                phone
                email
            }
        }
        class{
            id
            name
            instructor_name
            level
            points_cost
            cash_cost
            pay_points
            pay_cash
            business_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            is_online
            description
            instructor{
                id
                name
            }
            class_ratings_aggregate
            {
                aggregate 
                {
                    avg {
                        rating
                    }
                }
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                business_id
                location_city{
                    id
                    name
                    county_id
                }
            }
            business{
                id
                name
                logo
                is_private
                three_gym_memberships{
                    id
                    include_classes
                    three_user_gym_memberships(where: {end_date: {_gte: $todayDate}}){
                        id
                        user_id
                        membership_id
                        start_date
                        end_date
                    }
                }
                three_studio_memberships{
                    id
                    include_classes
                    three_user_studio_memberships(where: {end_date: {_gte: $todayDate}}){
                        id
                        user_id
                        membership_id
                        start_date
                        end_date
                    }
                }
            }
            categories{
                category{
                    id
                    name
                }
            }
        }
    }
}`;


const BOOKINGS_QUERY = gql`query{
    bookings(order_by: {day_date: desc, slot: {start_time: asc}}){
        id
        user_id
        slot_id
        points_cost
        cash_cost
        payment_by_points
        day_date
        uuid
        attended
        slot{
            id
            start_date
            end_date
            start_time
            end_time
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
            sunday
            points_cost
            cash_cost
            pay_points
            pay_cash            
            capacity
            instructor_name
            registered
            link
            bookings_counts{
                booking_day_date
                registered
            }
            class{
            id
            name
            instructor_name
            level
            points_cost
            cash_cost
            pay_points
            pay_cash            
            business_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            is_online
            description
            location{
                id
                address
                name
                latitude
                longitude
                url
                location_city{
                    id
                    name
                    county_id
                }
            }
            business{
                id
                name
                logo
                is_private
            }
            categories{
                category{
                    id
                    name
                }
            }
            }
            instructor{
                id
                name
                logo
            }
           
        }
    }
}`;

const BANK_ACCOUNT_QUERY = gql `query{
    user_bank_account{
        user_id
        merchant_id
    }
}
`;

const RATING_QUERY = gql `query($userId: Int!){
    
    class_rating(where: {user_id:{_eq: $userId}}){
        
        class_id
        rating
    }
}
`;


const NOTIFICATIONS_QUERY = gql `query{
    
    user_notification{
        
        id
        message
        read
    }
}
`;

const BUSINESS_NOTIFICATIONS_QUERY = gql `query($businessId: Int!){
    
    business_notification(where:{business_id:{_eq: $businessId}}){
        
        id
        message
        read
    }
}
`;

const CLASSES_BRAND_INSTRUCTOR_QUERY = gql`query($userId: Int!){
  
    class(where:{instructor: {user:{id: {_eq: $userId}}}}){
        id
        name
        points_cost
        cash_cost
        pay_points
        pay_cash        
        instructor_name
        instructor_id
        instructor{
            id
            name
        }
        business{
            name
            phone
        }
        location{
            id
            name
            address
            latitude
            longitude
            url
            location_city{
                id
                name
                county_id
            }
        }
    }
}`;

const INSTRUCTOR_SLOT_QUERY = gql`query($userId: Int!){

    slot(where:{instructor: {user:{id: {_eq: $userId}}}}, order_by:{start_date: asc, start_time: asc}) {
        id
        start_date
        end_date
        start_time
        end_time
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        points_cost
        cash_cost
        pay_points
        pay_cash        
        capacity
        instructor_name
        registered
        link
        males
        females
        bookings_counts{
            booking_day_date
            registered
        }
        instructor{
            id
            name
            logo
        }
        bookings{
            id
            user_id
            day_date
            uuid
            attended
            user{
                name
                picture
                gender
                date_of_birth
                phone
                email
            }
        }
        class{
            id
            name
            instructor_name
            level
            points_cost
            cash_cost
            pay_points
            pay_cash            
            business_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            is_online
            description
            instructor{
                id
                name
            }
            class_ratings_aggregate
            {
                aggregate 
                {
                    avg {
                        rating
                    }
                }
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                business_id
                location_city{
                    id
                    name
                    county_id
                }
            }
            business{
                id
                name
                logo
                is_private
            }
            categories{
                category{
                    id
                    name
                }
            }
        }
    }
}`;

const COUNTIES_QUERIES = gql`query($countryName: name!){

    location_country_county(where:{location_country: {name: {_eq: $countryName}}}){
        id
        name
        ar_name
    }
}`

const CITIES_QUERIES = gql`query($countryName: name!){

    location_country(where:{name: {_eq: $countryName}}){
        id
        name
        counties{
            id
            name
            cities{
                id
                name
            }
        }
    }
}`

const BRAND_PAGE_FULL_QUERY = gql`query($brandId: Int!){
    
    brand(where: {_and:[

        {is_instructor: {_eq: false}},
        {id: {_eq: $brandId}}
    ]})    {
            id
            name
            phone
            logo
            description
        brand_to_brand_categories{
            brand_category{
                id
                name
            }
        }
    }
}`;


const BUSINESS_PAGE_FULL_QUERY = gql`query($businessId: Int!){

    business(where:{id: {_eq: $businessId}}){
        id
        phone
        name
        address
        location_id
        owner_id
        logo
        license
        is_private
        sub_merchant_id
        verified
        brand{
            id
            logo
            name
            is_instructor
            description
            verified
        }
        location{
            id
            name
            latitude
            longitude
            url
            address
            business_id
            country
            location_city{
                id
                name
                county_id
            }
        }
        user_business_points{
            
            points
        }
    }
}`;

const INSTRUCTOR_PAGE_FULL_QUERY = gql`query($instructorId: Int!){
    
    brand(where: {_and:[

        {is_instructor: {_eq: true}},
        {id: {_eq: $instructorId}}
    ]})
        {
            id
            name
            phone
            logo
            description
        brand_to_brand_categories{
            brand_category{
                id
                name
            }
        }
    }
}`;

const CLASS_PAGE_FULL_QUERY =  gql`query($classId: Int!){

    class(where: {id: {_eq: $classId}}){
        id
        name
        instructor_name
        level
        points_cost
        cash_cost
        pay_points
        pay_cash        
        business_id
        image_1
        image_2
        image_3
        image_4
        image_5
        image_6
        image_7
        image_8
        is_online
        description
        instructor{
            id
            name
        }
        class_ratings_aggregate
        {
            aggregate 
            {
                avg {
                    rating
                }
            }
        }
        location{
            id
            name
            address
            latitude
            longitude
            url
            business_id
            location_city{
                id
                name
                county_id
            }
        }
        business{
            id
            name
            logo
            is_private
        }
        categories{
            category{
                id
                name
            }
        }
    }
    
}`;

const MEMBERSHIPS_RECORDS_QUERY =  gql`query($businessId: Int!){

    three_user_membership_record(where:{business_id:{_eq: $businessId}}, order_by: {updated_at: desc}){
        
        id
        user_id
        business_id
        cash
        points
        start_date
        end_date

        user{
            id
            name
        }
    }
}`;


// module.exports = {

// export default {
//     user_query: gql`query {
    
//         user{
//                 id
//                 name
//                 phone
//                 email
//                 address
//                 date_of_birth
//                 is_deactivated
//                 coins
//                 extra_coins
//                 picture
//                 }
                
//             }`,

//     token_query: gql`query {
//         token{
//             id
//             email
//             }
//         }`
// }


export default {

    big_bookings_query : BIG_BOOKINGS_QUERY,

   token_and_user_query: TOKEN_AND_USER_QUERY,

    token_query: TOKEN_QUERY,

    //user issue    
    my_user_query: MY_USER_QUERY,

    user_query: USER_INFO_QUERY,

    broker_user_info: BROKER_USER_INFO,

    //user issue, (Can be ignored)
    user_main_query :USER_MAIN_QUERY,

    //user issue, before: ios_user_query
    ios_token_user_query :iOS_TOKEN_USER_QUERY,

    class_user_query: CLASS_USER_QUERY,

    delegated_user_info_query: DELEGATED_USER_INFO_QUERY,

    all_delegated_users_query: ALL_DELEGATED_USERS_QUERY,

    instructor_query: INSTRUCTORS_QUERY,

    one_business_query:ONE_BUSINESS_QUERY,

    one_instructor_query: ONE_INSTRUCTOR_QUERY,

    brand_query: BRAND_QUERY,

    class_brand_query: CLASSES_BRAND_QUERY,

    brand_category_query: BRAND_CATEGORY_QUERY,

    all_business_query: ALL_BUSINESS_QUERY,
    
    business_query: BUSINESS_QUERY,

    broker_business: BROKER_BUSINESS,


    location_query: LOCATION_QUERY,

    all_class_query: ALL_CLASS_QUERY,

    class_query: CLASS_QUERY,

   
    class_gender_query: function(gender){

        if(gender == 'male'){

            return CLASS_MALES_QUERY;
        }
        else{

            return CLASS_FEMALES_QUERY;
        }
    },

    class_mixed_only_query: CLASS_MIXED_ONLY_QUERY,
    

    owner_business_query: OWNER_BUSINESS_QUERY,

    category_query: CATEGORY_QUERY,

    slot_my_business_query: SLOT_MY_BUSINESS_QUERY,

    fake_slot: FAKE_SLOTS,

    slot_query: SLOT_QUERY,

    slot_gender_query: function(gender){

        if(gender == 'male'){

            return SLOT_MALES_QUERY;
        }
        else{

            return SLOT_FEMALES_QUERY;
        }
    },

    slot_mixed_only_query: SLOT_MIXED_ONLY_QUERY,
        
    bookings_query: BOOKINGS_QUERY,

    bank_account_query :BANK_ACCOUNT_QUERY,
    
    rating_Query :RATING_QUERY,

    notificaions_query: NOTIFICATIONS_QUERY,

    business_notifications_query : BUSINESS_NOTIFICATIONS_QUERY,

    classes_brand_instructor_query: CLASSES_BRAND_INSTRUCTOR_QUERY,

    instructor_slot_query: INSTRUCTOR_SLOT_QUERY,

    counties_queries: COUNTIES_QUERIES,

    cities_queries: CITIES_QUERIES,

    brand_page_full_query: BRAND_PAGE_FULL_QUERY,

    business_page_full_query: BUSINESS_PAGE_FULL_QUERY,

    instructor_page_full_query: INSTRUCTOR_PAGE_FULL_QUERY,

    class_page_full_query: CLASS_PAGE_FULL_QUERY,

    memberships_record_query: MEMBERSHIPS_RECORDS_QUERY


}
// exports.myQueries = myQueries;

// exports.user_query = () => {

//     return USER_INFO_QUERY;
// }

// exports.token_query = () => {

//     return token_query;
// }

// exports.user_query = USER_INFO_QUERY;


// exports.token_query = token_query;